// Copyright 2026. WebPros International GmbH. All rights reserved.

import { COLORS } from 'common/theme';
import { StyledSvg } from 'common/components/Spinner/Styles';

interface IProps {
    size?: number;
}

export default function Spinner({
    size = 16,
}: IProps) {
    return (
        <StyledSvg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
        >
            <circle cx="8" cy="8" r="7" stroke={COLORS.GREY_25} strokeWidth="2"/>
            <path
                d="M14.9955 8.00001C15.5478 8.00001 16.0065 7.55056 15.9376 7.00259C15.7565 5.56171 15.1856 4.19046 14.2777 3.04106C13.1621 1.62886 11.603 0.634046 9.85222 0.217378C8.10147 -0.19929 6.26136 -0.0134725 4.62925 0.744805C2.99714 1.50308 1.66838 2.78952 0.857683 4.39624C0.0469889 6.00295 -0.198276 7.83609 0.161521 9.59941C0.521318 11.3627 1.46516 12.9532 2.84052 14.1139C4.21588 15.2746 5.94242 15.9376 7.74114 15.9958C9.20512 16.0432 10.6473 15.6877 11.9139 14.9773C12.3955 14.7071 12.4845 14.0711 12.1564 13.6269C11.8283 13.1826 11.2021 13.0936 10.7095 13.3433C9.81599 13.7964 8.81802 14.0207 7.80615 13.9879C6.45913 13.9443 5.16616 13.4478 4.13618 12.5786C3.1062 11.7094 2.39938 10.5183 2.12994 9.19776C1.86049 7.87725 2.04417 6.50446 2.65128 5.30122C3.25839 4.09799 4.25347 3.1346 5.47572 2.56675C6.69797 1.99889 8.07599 1.85973 9.38709 2.17177C10.6982 2.4838 11.8658 3.2288 12.7012 4.28636C13.3288 5.0808 13.7413 6.01676 13.9078 7.00462C13.9995 7.54923 14.4432 8.00001 14.9955 8.00001Z"
                fill={COLORS.INFO}
            />
        </StyledSvg>
    );
}
